import { useTheme } from "@/contexts/ThemeContext";
import { useMemo } from "react";

/**
 * Shared chart theme hook that provides consistent colors for Recharts
 * components across all pages. Recharts SVG elements cannot resolve CSS
 * custom properties, so we compute hex colors based on the active theme.
 */
export function useChartTheme() {
  const { theme } = useTheme();

  return useMemo(() => {
    const isDark = theme === "dark";
    return {
      // Text colors for axis labels, tick marks, legends
      textColor: isDark ? "#F2F5F9" : "#142033",
      // Muted text for secondary labels
      mutedTextColor: isDark ? "#929DB2" : "#5D6B82",
      // Grid line color
      gridColor: isDark ? "#212938" : "#D9E0EA",
      // Tooltip background
      tooltipBg: isDark ? "#141926" : "#FFFFFF",
      // Tooltip border
      tooltipBorder: isDark ? "#212938" : "#D9E0EA",
      // Tooltip text
      tooltipText: isDark ? "#F2F5F9" : "#142033",
      // Card/container background for chart areas
      chartBg: isDark ? "#141926" : "#FFFFFF",
      // Cursor/highlight color for hover states
      cursorColor: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
      // Income (cash in) color
      incomeColor: isDark ? "#2FD07A" : "#198754",
      // Expense (cash out) color
      expenseColor: isDark ? "#F0555A" : "#D83D44",
      // Whether dark mode is active
      isDark,
    };
  }, [theme]);
}
